const groupBy = <T, K extends keyof any>(arr: T[], key: (i: T, j: number) => K) =>
  arr.reduce((groups, item, currentIndex) => {
    (groups[key(item, currentIndex)] ||= []).push(item);
    return groups;
  }, {} as Record<K, T[]>);

export default groupBy;
